module.exports = __webpack_public_path__ + "img/cat_mouse.712185e6.jpg";